import { ROUTE } from "../../routes";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import SharedPropsService from "../../SharedPropsService";
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const retryAction = async (action, _datastore, { navigate, network }) => {
    const user = await SharedPropsService.getUser();
    const retryDocumentUploadResponse = await network.get(`${api.retryDocumentUpload}${user.linkedApplications[0].applicationId}/${user.linkedApplications[0].currentStepId}`, {
        headers: await getAppHeader(),
    });
    if (retryDocumentUploadResponse?.status === 200) {
        await navigate(ROUTE.AS_ES_DOCUMENTS_LISTING);
    }
};
